<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Controle do Ponto</h5>
                <hr>
                <TabMenu :model="items" class="p-mb-5"/>
                <router-view />
			</div>
		</div>
  </div>
</template>

<script>

export default {  
    data() {
        return {     
            items: [
                {label: 'Controle', to: '/movimento/controle-ponto'},
                {label: 'Marcações', to: '/movimento/controle-ponto/marcacoes'},               
            ]
        }
    },   
}
</script>

<style>

</style>